<template>
  <div v-if="app" class="card">
    <div class="row">
      <div class="col-2">
        <img src="@/assets/img/Fleet.png" class="img-fluid" alt="Fleet" />
      </div>
      <div class="col p-3">
        <div class="headline">Application mobile Fleet</div>
        <div class="subline">Les dernières release de l'application</div>
      </div>
    </div>

    <ul class="list-group list-group-flush">
      <li class="list-group-item headline">
        <div class="row">
          <div class="col-2">Version</div>
          <div class="col-3">Date</div>
          <div class="col">Commentaire</div>
          <div class="col-2">Liens</div>
        </div>
      </li>
      <li class="list-group-item">
        <div class="row">
          <div class="col-2">{{ app.version }}</div>
          <div class="col-2">
            {{ moment(app.date_version).format("DD/MM/YYYY") }}
          </div>
          <div class="col comment">
            {{ start_comment[1] ? start_comment[0] : null }}
            <ul>
              <li v-for="line in formated_comment" :key="line">{{ line }}</li>
            </ul>
          </div>
          <div class="col-2">
            <a
              :href="`https://play.google.com/store/apps/details?id=com.fleetagrivitech&hl=en_US&gl=US`"
              target="blank"
              ><i class="fab fa-google-play mr-2"></i
            ></a>
            <a
              :href="`https://apps.apple.com/fr/app/fleet-agrivitech/id1523653744`"
              target="blank"
              ><i class="fab fa-app-store mr-2"></i
            ></a>
            <a :href="app.download_link"><i class="fab fa-android"></i></a>
          </div>
        </div>
      </li>
    </ul>

    <hr />
    <a
      class="btn btn-secondary-outline btn-sm"
      :href="`https://fleet.agrivitech.com`"
      target="blank"
      >Accéder au dashboard</a
    >
  </div>

  <div v-else>
    <div class="card">
      <div class="row">
        <div class="col-2">
          <img src="@/assets/img/Fleet.png" class="img-fluid" alt="Fleet" />
        </div>
        <div class="col">
          <div class="headline">Vous n'êtes pas encore client Fleet</div>
          <router-link class="btn btn-primary mx-auto" to="/contact-demo">
            Demandez une présentation
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { computed } from "@vue/runtime-core";
export default {
  name: "AccessFleet",
  props: ["app"],
  setup(props) {
    const start_comment = computed(() => {
      return props.app.comment.split(" : ");
    });
    const formated_comment = computed(() => {
      return start_comment.value
        ? start_comment.value[1].split(". ")
        : props.app.comment.split(". ");
    });
    return {
      moment,
      formated_comment,
      start_comment,
    };
  },
};
</script>

<style lang="scss" scoped>
.comment {
  white-space: pre-wrap;
}

.appIcon {
  border-radius: 8px;
  max-height: 50px;
}

.headline {
  font-size: 30px;
  font-weight: 700;
}
.subline {
  font-size: 14px;
  color: var(--mainGreen);
}
.logoClient {
  max-height: 70px;
  position: absolute;
  right: 15px;
  top: 0px;
}
.list-group {
  .headline {
    font-size: 13px;
    font-weight: 700;
  }
  &.out {
    color: gray;
  }
}
.list-group {
  .headline {
    font-size: 13px;
    font-weight: 700;
  }
  .out {
    color: gray;
    cursor: default;
  }
}

.card {
  border-radius: var(--border-radius, 6px);
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
  border: none;
  padding: 15px;
  margin-bottom: 25px;
  .headline {
    font-size: 17px;
    margin-top: 0;
    margin-bottom: 10px;
  }
  .logoClient {
    max-height: 70px;
    position: absolute;
    right: 15px;
    top: 0px;
  }
  .partLogo {
    max-width: 200px;
  }
  .logoApp {
    max-width: 50px;
  }
  .list-group {
    .headline {
      font-size: 13px;
      font-weight: 700;
    }
    &.out {
      color: gray;
    }
  }
  .list-group {
    .headline {
      font-size: 13px;
      font-weight: 700;
    }
    .out {
      color: gray;
      cursor: default;
    }
  }
}
</style>